import { SERVER_ADDRESS } from '../settings';

const customHeader = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: 'Bearer ' + localStorage.getItem('token'),
});

const base = (method, url, data = {}) => {

  const initRequest = {
    method: method,
    headers: customHeader(),
  }

  if (method == "post") {
    initRequest["body"] = JSON.stringify(data);
  }

  return fetch(`${SERVER_ADDRESS}${url}`, initRequest)
    .then(response => {
      return response.text();
    })
    .then(res => {
      if(res) {
        return JSON.parse(res);
      } else {
        return {};
      }
    })
    .catch(error => ({ error: error }));
};

const SuperFetch = {};
['get', 'post', 'put', 'delete'].forEach(method => {
  SuperFetch[method] = base.bind(null, method);
});

export default SuperFetch;
